import React, { useEffect } from 'react'
import { Button } from 'ui/common/button'
import { ColumnLayout, RowLayout } from 'ui/common/layout'
import { authenticateApple, authenticateKakaoWeb } from 'api/writes'
import { BaseText, getLegacyFontStyle } from 'ui/common/text'
import { Image } from 'react-native'
import { KAKAO_ICON } from 'image/icon'
import { authStore } from 'store/auth'
import { alertError } from 'infra/util'
import { colors } from 'infra/color'
import { startKakaoLogin, appleSignIn, consumeKakaoRedirect } from 'auth-web'

export const AuthScreen = () => {
  // Handle the Kakao redirect callback (`/auth/kakao/callback?code=...`).
  useEffect(() => {
    const pending = consumeKakaoRedirect()
    if (!pending) return
    ;(async () => {
      try {
        const token = await authenticateKakaoWeb(
          pending.code,
          pending.redirectUri,
        )
        authStore.setToken(token)
        window.history.replaceState({}, '', '/')
      } catch (e) {
        alertError(e)
        window.history.replaceState({}, '', '/')
      }
    })()
  }, [])

  return (
    <ColumnLayout
      style={{
        flex: 1,
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: colors.white,
      }}
    >
      <ColumnLayout style={{ marginTop: 80, marginBottom: 8, width: '100%' }}>
        <BaseText style={{ marginLeft: 30, ...getLegacyFontStyle(28, 1.5) }}>
          {'쉽고 빠르게\n가고 싶은 장소\n찾아보고\n어디든'}
        </BaseText>
        <BaseText
          style={{
            marginLeft: 30,
            fontWeight: 900,
            ...getLegacyFontStyle(40, 1.5),
          }}
        >
          GOGO
        </BaseText>
      </ColumnLayout>
      <ColumnLayout style={{ width: '100%', marginBottom: 80 }}>
        <RowLayout
          style={{
            marginHorizontal: 28,
            borderWidth: 1,
            borderColor: '#F7DE10',
            borderStyle: 'solid',
            borderRadius: 24,
            overflow: 'hidden',
          }}
        >
          <Button
            buttonStyle={{
              flex: 1,
              backgroundColor: '#F7DE10',
              borderWidth: 0,
            }}
            textStyle={getLegacyFontStyle(18)}
            title='카카오톡으로 시작하기'
            onPress={async () => {
              try {
                // Redirects to Kakao; the callback is handled on load above.
                await startKakaoLogin()
              } catch (e) {
                alertError(e)
              }
            }}
            leftChildren={
              <Image
                source={KAKAO_ICON}
                style={{ width: 24, height: 24, marginRight: 12 }}
              />
            }
          />
        </RowLayout>
        <RowLayout
          style={{
            marginTop: 16,
            marginHorizontal: 28,
            borderWidth: 1,
            borderColor: '#000',
            borderStyle: 'solid',
            borderRadius: 24,
            overflow: 'hidden',
          }}
        >
          <Button
            buttonStyle={{ flex: 1, backgroundColor: '#000', borderWidth: 0 }}
            textStyle={{ ...getLegacyFontStyle(18), color: colors.white }}
            title=' Apple로 계속하기'
            onPress={async () => {
              try {
                const idToken = await appleSignIn()
                if (!idToken) return
                const token = await authenticateApple(idToken)
                authStore.setToken(token)
              } catch (e) {
                alertError(e)
              }
            }}
          />
        </RowLayout>
      </ColumnLayout>
    </ColumnLayout>
  )
}
